module.exports = __webpack_public_path__ + "static/media/privacy.4feaa806.jpeg";